const ArticlesAPIState = {
    DRAFT_ARTICLES: "draft",
    SUBMITTED_ARTICLES: "submitted",
    APPROVED_ARTICLES: "approved",
    QUEUED_ARTICLES: "queued",
    LIVE_ARTICLES: "live",
    IN_REVIEW :"inReview"
}
export default ArticlesAPIState;